module.exports = __webpack_public_path__ + "img/character_lineup_perspective_thumb.17c44779.jpg";